import _ from 'lodash';

const sortArray = (array, keys, reverse, caseSensitive) => {
  if (!Array.isArray(array)) {
    return array;
  }

  if (caseSensitive === true) {
    return typeof reverse !== 'undefined' && reverse === true
      ? _.orderBy(array, [item => item[keys].toLowerCase()], ['desc'])
      : _.orderBy(array, [item => item[keys].toLowerCase()], ['asc']);
  }

  if (!Array.isArray(keys)) {
    keys = [].concat(keys);
  }

  return typeof reverse !== 'undefined' && reverse === true
    ? _.sortBy(array, keys).reverse()
    : _.sortBy(array, keys);
};

export default sortArray;



// WEBPACK FOOTER //
// ./src/helpers/sortArray.js